import React, { useEffect, createElement } from 'react';
export function LandingPage() {
  useEffect(() => {
    // Load LeadConnector form embed script
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-gradient-to-b from-blue-50 to-white" data-id="element-5">
      <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-6">
        
        <div className="bg-white rounded-lg shadow-lg overflow-hidden" style={{
        minHeight: '500px'
      }} data-id="element-7">
          <iframe src="https://api.leadconnectorhq.com/widget/survey/iiMWY9kvnXEvpE11rfro" style={{
          border: 'none',
          width: '100%',
          minHeight: '500px'
        }} scrolling="no" id="iiMWY9kvnXEvpE11rfro" title="survey" data-id="element-8" />
        </div>
        <div className="mt-8 text-center text-sm text-gray-500" data-id="element-9">
          <p data-id="element-10">
            Tu información está segura y nunca será compartida con terceros.
          </p>
        </div>
      </div>
    </div>;
}